import {Stack, Typography, Box} from '@mui/material';
import {useClient} from '../../../../context/ClientContext';
import {ClientOptionButton} from '../../common/ClientOptionButton';
import StepsHeading from '../../common/StepsHeading';

export default function MenopausalStatus({userData, setUserData, onNext}) {
  const {theme} = useClient();

  // Only show this screen if user is female and not pregnant
  const shouldShowScreen = userData.genderId === 2 && (userData.isPregnant === false || userData.isPregnantId === 3);

  if (!shouldShowScreen) {
    // Skip this screen if conditions aren't met
    onNext();
    return null;
  }

  const handleOptionSelect = (menopausalStatus, menopausalStatusId) => {
    setUserData(prev => ({
      ...prev,
      menopausalStatus: menopausalStatus,
      menopausalStatusId: menopausalStatusId,
    }));
    // Call onNext directly after selection to move to the next step
    onNext();
  };

  return (
    <Stack
      spacing={2}
      sx={{
        width: '100%',
        maxWidth: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
      }}
    >
      <StepsHeading title={'What best describes your current menopausal status?'} />
      {[
        {
          heading: 'I have not started menopause',
          description: 'pre-menopausal',
          id: 1,
          value: 'I have not started menopause (pre-menopausal)',
        },
        {
          heading: 'I am in perimenopause',
          description: 'transition phase with irregular periods and/or symptoms',
          id: 2,
          value: 'I am in perimenopause (transition phase with irregular periods and/or symptoms)',
        },
        {
          heading: 'I am in menopause',
          description: '12 consecutive months without a period, not due to other causes',
          id: 3,
          value: 'I am in menopause (12 consecutive months without a period, not due to other causes)',
        },
        {
          heading: 'I am post-menopausal',
          description: 'more than 12 months since my last period',
          id: 4,
          value: 'I am post-menopausal (more than 12 months since my last period)',
        },
        {
          heading: 'I am unsure',
          description: '',
          id: 5,
          value: 'I am unsure',
        },
      ].map((option, index) => (
        <ClientOptionButton
          optionSelectSingleValue={userData.menopausalStatusId}
          value={option.id}
          key={index}
          option={
            <Box sx={{textAlign: 'center'}}>
              <Typography sx={{fontWeight: 'bold'}}>{option.heading}</Typography>
              {option.description && <Typography sx={{fontSize: '0.9em', mt: 0.5}}>{option.description}</Typography>}
            </Box>
          }
          onClick={() => handleOptionSelect(option.value, option.id)}
        />
      ))}
    </Stack>
  );
}
